export const BASE_URL = process.env.REACT_APP_API_URL;

export type ApiResponse<T> = {
  status: number;
  body: T | { message: string };
};

async function getFromServer<T>(url: string): Promise<ApiResponse<T>> {
  try {
    const response = await fetch(`${BASE_URL}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (response.ok) {
      const data: T = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      console.error(`Erreur de la requête: ${JSON.stringify(errorData)}`);
      return {
        status: response.status,
        body: { message: errorData.message || "Une erreur est survenue" },
      };
    }
  } catch (error) {
    console.error("Erreur lors de la requête:", error);
    return {
      status: 500,
      body: { message: "Erreur interne du serveur" },
    };
  }
}

async function postToServer<T, U>(
  url: string,
  input: T,
): Promise<ApiResponse<U>> {
  try {
    let fetchOptions: any = {
      method: "POST",
      credentials: "include",
    };
    if (input instanceof FormData) {
      fetchOptions.body = input;
    } else {
      fetchOptions.headers = {
        "Content-Type": "application/json",
        accept: "application/json",
      };
      fetchOptions.body = JSON.stringify(input);
      fetchOptions.credentials = "include";
    }
    const response = await fetch(`${BASE_URL}${url}`, fetchOptions);

    if (response.ok) {
      const data: U = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: { message: errorData.message || "An error occurred" },
      };
    }
  } catch (error) {
    return {
      status: 500,
      body: { message: "Internal Server Error" },
    };
  }
}

async function patchToServer<T, U>(
  url: string,
  input: T,
): Promise<ApiResponse<U>> {
  try {
    let fetchOptions: any = {
      method: "PATCH",
      credentials: "include",
    };
    if (input instanceof FormData) {
      fetchOptions.body = input;
    } else {
      fetchOptions.headers = {
        "Content-Type": "application/json",
        accept: "application/json",
      };
      fetchOptions.body = JSON.stringify(input);
      fetchOptions.credentials = "include";
    }
    const response = await fetch(`${BASE_URL}${url}`, fetchOptions);

    if (response.ok) {
      const data: U = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: { message: errorData.message || "An error occurred" },
      };
    }
  } catch (error) {
    return {
      status: 500,
      body: { message: "Internal Server Error" },
    };
  }
}

export { getFromServer, postToServer, patchToServer };
